/**
 * Case-insensitive pathname comparison for redirect loop prevention.
 * Trailing slashes are ignored (app enforces them on routes).
 */
export function normalizePathForRedirectComparison(pathname: string): string {
  let normalized = pathname.toLowerCase();

  if (normalized.length > 1 && normalized.endsWith('/')) {
    normalized = normalized.slice(0, -1);
  }

  return normalized;
}

export function redirectPathsAreEquivalent(
  leftPathname: string,
  rightPathname: string
): boolean {
  return (
    normalizePathForRedirectComparison(leftPathname) ===
    normalizePathForRedirectComparison(rightPathname)
  );
}
